const USER_PRIVACY_STATUS_PRIVATE = 'PRIVATE';
const USER_PRIVACY_STATUS_PUBLIC = 'PUBLIC';
module.exports = {
  USER_PRIVACY_STATUS_PRIVATE,
  USER_PRIVACY_STATUS_PUBLIC
};